import { render, staticRenderFns } from "./InputAmountButtons.vue?vue&type=template&id=190b1c2a&scoped=true&"
import script from "./InputAmountButtons.vue?vue&type=script&lang=js&"
export * from "./InputAmountButtons.vue?vue&type=script&lang=js&"
import style0 from "./InputAmountButtons.vue?vue&type=style&index=0&id=190b1c2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190b1c2a",
  null
  
)

export default component.exports